


















































































































































































import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import Vue from "vue";
import { pdf_state } from "../data/pdf/state.pdf";
import Preview2 from "../preview/Preview2.vue";
import draggable from "vuedraggable";
import { UseModal } from "@/components/root/modal";
import PreviewA4ModalVue from "../preview/PreviewA4Modal.vue";
import AccessLevelToggle from "./AccessLevelToggle.vue";
import {
  ReportScheduleOption,
  GeneratorReportTemplateSection,
  ReportTemplateSection,
  TemplateGeneratorHelper,
  ReportTemplateAccess,
} from "../data/pdf/model";
import { state as reports_state } from "@/views/reports/data/state";
import { clone } from "@/fp";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import { omit } from "@/fp";
import ReportSectionItem from "./ReportSectionItem.vue";
import { SharedState } from "@/common/state";
import { ICONS } from "@/common/icons.map";
import EmailListModalVue from "../scheduled-reports/EmailListModal.vue";
import ScheduledButtons from "../scheduled-reports/ScheduledButtons.vue";

type EditModeGenerateReportTemplateSection = GeneratorReportTemplateSection & {
  selected: boolean;
};

const from_edit_mode = omit<EditModeGenerateReportTemplateSection>("selected");

export default Vue.extend({
  components: {
    PageWithMainContainer,
    Preview2,
    draggable,
    ReportSectionItem,
    ScheduledButtons,
    AccessLevelToggle,
  },
  setup(_, { root: { $router } }) {
    const mode = ref("new");
    const report_name = ref("");
    const access: Ref<ReportTemplateAccess> = ref("private");
    const selected_schedule: Ref<ReportScheduleOption> = ref("none");
    const email_list: Ref<string[]> = ref([]);

    const info_types: Ref<Array<{
      id: string;
      name: string;
      icon: string;
    }>> = ref([]);

    const {
      template_questions,
      save_template,
      delete_template,
      update_template,
    } = pdf_state;

    const possible_sections: Ref<EditModeGenerateReportTemplateSection[]> = ref(
      []
    );

    const report_sections = computed(() =>
      possible_sections.value.filter((s) => s.selected)
    );

    const has_pdf_report_schedule_feature = computed(() =>
      SharedState.FeatureHelper.is_enabled("pdf_report_schedule")
    );

    const change_report_name = (name: string) => {
      report_name.value = name;
      has_changes.value = check_has_changes();
    };

    const set_selected_section = (
      section: ReportTemplateSection & { selected: boolean },
      selected: boolean
    ) => {
      section.selected = selected;
      has_changes.value = check_has_changes();
    };

    const set_selected_l0s = (
      section: EditModeGenerateReportTemplateSection,
      selected_labels: Array<{ id: string; name: string }>
    ) => {
      section.parameters_values!.l0_label = selected_labels;
      has_changes.value = check_has_changes();
    };

    const show_large_preview = () => {
      UseModal().show(PreviewA4ModalVue, {
        type: "full",
        sections: TemplateGeneratorHelper.spread_sections(
          report_sections.value.map(from_edit_mode)
        ),
      });
    };

    const is_valid_schedule_section = computed(() => {
      if (selected_schedule.value == "none") {
        return true;
      } else {
        return email_list.value.length > 0;
      }
    });

    const is_valid_report = computed(
      () =>
        report_name.value.length > 0 &&
        report_sections.value.length > 0 &&
        is_valid_schedule_section.value
    );

    const expend_img = (a4_img: string) => {
      UseModal().show(PreviewA4ModalVue, {
        type: "single",
        img: a4_img,
      });
    };

    const open_email_list_modal = async () => {
      const res = await UseModal().show(EmailListModalVue, {
        emails: email_list.value,
      });
      if (res.type == "success") {
        // @ts-ignore
        email_list.value = res.msg;
        has_changes.value = check_has_changes();
      }
    };

    const remove_email = (email: string) => {
      email_list.value = email_list.value.filter((r) => r != email);
      has_changes.value = check_has_changes();
    };

    const set_access = (access_val: ReportTemplateAccess) => {
      access.value = access_val;
      has_changes.value = check_has_changes();
    };

    const save = async () => {
      if (mode.value == "edit") {
        const report = pdf_state.report_templates.items.value.find(
          (r) => r.id == $router.currentRoute.query.id
        )!;
        const is_report_scheduled =
          email_list.value.length > 0 && selected_schedule.value != "none";
        if (is_report_scheduled) {
          const was_report_not_scheduled = report.scheduled == "none";
          const res = await UseModal().showSimple({
            title: "Update Scheduled Report",
            desc: was_report_not_scheduled
              ? "Please note, you are about to schedule this report, are you sure?"
              : "This report is scheduled. Are you sure you want to update it?",
            submitBtnText: "Update",
            cancelBtnText: "Cancel",
          });
          if (res.type == "canceled") return;
        } else {
          const was_report_scheduled = report.scheduled != "none";
          if (was_report_scheduled) {
            const res = await UseModal().showSimple({
              title: "Update Scheduled Report",
              desc:
                "This report is currently scheduled, and recipients are expecting to receive it. <br/> Are you sure you want to remove the schedule for this report?",
              submitBtnText: "Update",
              cancelBtnText: "Cancel",
            });
            if (res.type == "canceled") return;
          }
        }

        await update_template({
          ...report,
          name: report_name.value,
          access: SharedState.is_biz_user.value ? "private" : access.value,
          sections: [
            ...TemplateGeneratorHelper.spread_sections(
              report_sections.value.map(from_edit_mode)
            ),
          ],
          scheduled: selected_schedule.value,
          mailing_list: email_list.value,
        });
        has_changes.value = false;
      } else {
        await save_template({
          name: report_name.value,
          access: SharedState.is_biz_user.value ? "private" : access.value,
          sections: [
            ...TemplateGeneratorHelper.spread_sections(
              report_sections.value.map(from_edit_mode)
            ),
          ],
          scheduled: selected_schedule.value,
          mailing_list: email_list.value,
        });
      }
      $router.back();
    };

    const has_changes = ref(false);

    const delete_the_template = async () => {
      let desc;
      if (selected_schedule.value != "none") {
        desc =
          "Are you sure you want to delete this template and unschedule it?";
      } else {
        desc = "Are you sure you want to delete this template?";
      }
      const res = await UseModal().showSimple({
        title: "Delete Template",
        desc,
        submitBtnText: "Delete",
        cancelBtnText: "Cancel",
      });
      if (res.type == "success") {
        const report_id = $router.currentRoute.query.id as string;
        if (report_id) {
          await delete_template(report_id);
          $router.back();
        }
      }
    };

    const set_selected_schedule = (schedule: ReportScheduleOption) => {
      selected_schedule.value = schedule;
      has_changes.value = check_has_changes();
    };

    const check_has_changes = () => {
      const current_report = pdf_state.report_templates.items.value.find(
        (r) => r.id == $router.currentRoute.query.id
      )!;
      if (!current_report) {
        return true;
      }
      const is_access_changed = current_report.access != access.value;
      if (is_access_changed) return true;

      const is_name_changed = current_report.name != report_name.value;
      if (is_name_changed) return true;

      const is_schedule_changed =
        current_report.scheduled != selected_schedule.value;
      if (is_schedule_changed) return true;

      const is_emailing_list_changed =
        current_report.mailing_list.sort().join(",") !=
        email_list.value.sort().join(",");
      if (is_emailing_list_changed) return true;

      const current_report_sections = current_report.sections
        .map(
          (s) =>
            s.id +
            Object.values(s.parameters_values || { "": { name: "" } })
              .map((d) => d.name)
              .sort()
              .join(",")
        )
        .join("-");
      const edited_report_sections = TemplateGeneratorHelper.spread_sections(
        clone(report_sections.value, true).map(from_edit_mode)
      )
        .map(
          //
          (s) =>
            s.id +
            Object.values(s.parameters_values || { "": { name: "" } })
              .map((d) => d.name)
              .sort()
              .join(",")
        )
        .join("-");
      const is_sections_changed =
        current_report_sections != edited_report_sections;
      return is_sections_changed;
    };

    const go_back = async () => {
      if (mode.value == "edit") {
        if (check_has_changes()) {
          const res = await UseModal().showSimple({
            title: "Unsaved Changes",
            desc:
              "Are you sure you want to leave this page without saving your changes?",
            submitBtnText: "Leave",
            cancelBtnText: "Cancel",
          });
          if (res.type == "success") {
            $router.back();
          }
          // prompt to save them
        } else {
          $router.back();
        }
      } else {
        $router.back();
      }
    };

    onMounted(async () => {
      await reports_state.init();
      //@ts-ignore
      possible_sections.value = TemplateGeneratorHelper.group_sections_by_id(
        clone(template_questions.value, true).map((d) => {
          return {
            ...d,
            selected: false,
          };
        })
      );

      info_types.value = SharedState.l0_known_content_info_types.value
        // @ts-ignore
        .filter((d) => !d.is_restricted)
        .map((d) => {
          return {
            id: d.id,
            name: d.labelName,
            icon: ICONS.L0_ICONS.get(d.code),
          };
        });
      const { action } = $router.currentRoute.query;
      // @ts-ignore
      mode.value = action == action ? action : "new";
      if (action == "edit") {
        const report = clone(
          pdf_state.report_templates.items.value.find(
            (r) => r.id == $router.currentRoute.query.id
          )!,
          true
        );
        selected_schedule.value = report.scheduled || "none";
        access.value = report.access ? report.access : "private";
        email_list.value = report.mailing_list || [];
        console.log("report::", report);
        report_name.value = report.name;
        const normalized_grouped_sections = TemplateGeneratorHelper.group_sections_by_id(
          report.sections
        );

        possible_sections.value = possible_sections.value.map((s) => {
          const s1 = normalized_grouped_sections.find((d) => d.id == s.id);
          if (s1) {
            s.selected = true;
            s.parameters_values = clone(s1!.parameters_values, true);
          }
          return s;
        });
      }
    });

    return {
      mode,
      go_back,
      is_sys_admin: SharedState.is_sys_user,
      access,
      set_access,
      selected_schedule,
      set_selected_schedule,
      email_list,
      open_email_list_modal,
      has_pdf_report_schedule_feature,
      remove_email,
      report_name,
      info_types,
      possible_sections,
      report_sections,
      change_report_name,
      set_selected_section,
      set_selected_l0s,
      template_questions,
      show_large_preview,
      //  add_or_update_question,
      is_valid_schedule_section,
      is_valid_report,
      has_changes,
      save,
      delete_template,
      // remove_section,
      expend_img,
      delete_the_template,
    };
  },
});
